import React from 'react';
import * as PropTypes from 'prop-types';
import { Wrapper } from './elements';
import ACI001 from '../ACI001';

type Props = {
  className?: string;
  title: string;
  value: number | string;
  icon: string;
  color: string;
  activityIcon: string;
  readonly activityUnavailable?: boolean;
};

function ASB002(props: Props): React.ReactElement {
  return (
    <Wrapper className={props.className}>
      <ACI001
        title={props.title}
        value={props.value}
        icon={props.icon}
        color={props.color}
        activityIcon={props.activityIcon}
        activityUnavailable={props.activityUnavailable}
      />
    </Wrapper>
  );
}

ASB002.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  value: PropTypes.node,
  icon: PropTypes.string,
  color: PropTypes.string,
  activityIcon: PropTypes.string,
};

export default ASB002;
